import { LademittelModel } from '../../../../models/LademittelModel';
import { VerpackungModel } from '../../../../models/VerpackungModel';
import { WaehrungModel } from '../../../../models/WaehrungModel';
import Gefahrgut from '../../gefahrgut/Gefahrgut';
import { nameof } from '../../../../utils/objectUtils';
import { Auftragsposition } from '../../../../api';
import { toSelectOptions } from '../../../../components/select/SelectModel';
import { TableConfig } from '../../../../components/table/Table';

export const initAuftragsPosTableConfigMetro = (
  mandantSpezi29: boolean,
  isLaengePflichtfeld: boolean,
  isBreitePflichtfeld: boolean,
  isHoehePflichtfeld: boolean,
  waehrungen: WaehrungModel[],
  lademittel?: LademittelModel[],
  verpackungen?: VerpackungModel[]
): TableConfig => {
  return [
    {
      id: 1,
      columnName: 'Pos. ',
      attributName: nameof<Auftragsposition>('auftptNum'),
      valueType: 'button',
    },
    {
      id: 2,
      columnName: 'Anzahl',
      attributName: nameof<Auftragsposition>('verpackungAnzahl'),
      valueType: 'number',
    },
    {
      id: 3,
      columnName: 'Verpackung',
      attributName: nameof<Auftragsposition>('verpackung'),
      valueType: 'select',
      selectData: toSelectOptions(verpackungen, 'kurzBezeichnung'),
    },
    {
      id: 4,
      columnName: 'Anzahl',
      attributName: nameof<Auftragsposition>('lademittelAnzahl'),
      valueType: 'number',
    },
    {
      id: 5,
      columnName: 'Lademittel',
      attributName: nameof<Auftragsposition>('lademittel'),
      valueType: 'select',
      selectData: toSelectOptions(lademittel, 'bezkurz'),
    },

    {
      id: 6,
      columnName: 'Inhalt *',
      attributName: nameof<Auftragsposition>('warengutBezeichnung'),
      valueType: 'string',
      minWidth: '300',
    },
    {
      id: 7,
      columnName: 'Gewicht *',
      attributName: nameof<Auftragsposition>('bruttoGewicht'),
      valueType: 'float',
    },
    {
      id: 8,
      columnName: 'ADR',
      attributName: nameof<Auftragsposition>('mitGefahrguetern'),
      valueType: 'sliderbutton',
      openSpecificModal: Gefahrgut,
    },
    {
      id: 9,
      columnName: 'Länge(cm) *',
      attributName: nameof<Auftragsposition>('laengeCM'),
      valueType: 'float',
    },
    {
      id: 10,
      columnName: 'Breite(cm) *',
      attributName: nameof<Auftragsposition>('breiteCM'),
      valueType: 'float',
    },
    {
      id: 11,
      columnName: 'Höhe(cm) *',
      attributName: nameof<Auftragsposition>('hoeheCM'),
      valueType: 'float',
    },
    {
      id: 12,
      columnName: 'Volumen(m³)',
      attributName: nameof<Auftragsposition>('volumenCBM'),
      valueType: 'float',
    },
    {
      id: 13,
      columnName: 'Stellplätze',
      attributName: nameof<Auftragsposition>('anzahlStellplaetze'),
      valueType: 'float',
    },
    {
      id: 14,
      columnName: 'Lademeter',
      attributName: nameof<Auftragsposition>('lademeter'),
      valueType: 'float',
    },
    {
      id: 15,
      columnName: 'Zeichen/Nr.',
      attributName: nameof<Auftragsposition>('zeichenNummer'),
      valueType: 'string',
    },
    {
      id: 16,
      columnName: 'Versicherungswert',
      attributName: nameof<Auftragsposition>('versicherungswert'),
      valueType: 'float',
      fixedDecimalScale: true,
    },
    {
      id: 17,
      columnName: 'in',
      attributName: nameof<Auftragsposition>('waehrungVersicherungswert'),
      valueType: 'select',
      selectData: toSelectOptions([...waehrungen], 'bezeichnungKurz'),
    },
    {
      id: 18,
      columnName: 'Warenwert',
      attributName: nameof<Auftragsposition>('warenwert'),
      valueType: 'float',
      fixedDecimalScale: true,
    },
    {
      id: 19,
      columnName: 'in',
      attributName: nameof<Auftragsposition>('warenwertWaehrung'),
      valueType: 'select',
      selectData: toSelectOptions([...waehrungen], 'bezeichnungKurz'),
    },
  ];
};
